// extracted by mini-css-extract-plugin
export default {"labelCell":"SpecificGradingScaleForm-module__labelCell--AXaAf","footer":"SpecificGradingScaleForm-module__footer--pOWGD"};